import { useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
// import SearchFilters from "../../../../Core/SearchFilters/SearchFilters";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
// import { useGetContactsQuery } from "../../../../store/api/contactapi";

import ExportCSV from "../../../../Core/Export/ExportCSV";
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";

import { useDeleteDocMutation } from "../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../utils/useScreenHeight";
const dummyContactsResponse = {
  data: [
    {
      siNo: 1,
      Id: 101,
      CustomerName: "Rahul Kumar",
      ContactNo: "9876543210",
      PassIDCustomerEntryForm: "PASS-CEF-001",
      CustomerType: "Retail",
      DateTime: "2025-01-10 10:30:00",
    },
    {
      siNo: 2,
      Id: 102,
      CustomerName: "Amit Singh",
      ContactNo: "9123456780",
      PassIDCustomerEntryForm: "PASS-CEF-002",
      CustomerType: "Wholesale",
      DateTime: "2024-06-15 14:20:00",
    },
    {
      siNo: 3,
      Id: 103,
      CustomerName: "Neha Verma",
      ContactNo: "9988776655",
      PassIDCustomerEntryForm: "PASS-CEF-003",
      CustomerType: "Distributor",
      DateTime: "2023-03-05 09:00:00",
    },
    {
      siNo: 4,
      Id: 104,
      CustomerName: "Suresh यादव",
      ContactNo: "9090909090",
      PassIDCustomerEntryForm: "PASS-CEF-004",
      CustomerType: "Retail",
      DateTime: "2025-02-01 18:45:00",
    },
  ],
};

const MainList = () => {
  const navigate = useNavigate();
  const { screenHeight, screenScaling, pageSize } = useScreenHeight();
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [showColumnConfig, setShowColumnConfig] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  //states used for deleting the record
  const [deleteDoc] = useDeleteDocMutation();
  const [delPopupVisible, setDelPopupVisible] = useState(false);
  const [delSelectedId, setDelSelectedId] = useState(null);
  const [delmessage, setDelmessage] = useState();
  const [alreadySubmitData, setAlreadySubmitData] = useState(false);
  const [delDone, setDelDone] = useState(false);
  const data = dummyContactsResponse;
  const isLoading = false;
  const refetchGetContact = () => {};
  //   const { data, isLoading, refetch:refetchGetContact } = useGetContactsQuery();
  const contacts = data?.data || [];
  const [showExportPopup, setShowExportPopup] = useState(false);
  const contactsWithSiNo = contacts.map((item, index) => ({
    ...item,
    siNo: index + 1,
  }));
  const filtersConfig = [
    { name: "siNo", label: "SI.No", type: "number", width: "12%", gap: "0px" },

    { name: "Id", label: "Id", type: "text", width: "10%" },
    {
      name: "CustomerName",
      label: "Customer Name",
      type: "text",
      width: "12%",
      gap: "0px",
    },
    { name: "ContactNo", label: "Contact No.", type: "text", width: "10%" },
    {
      name: "Pass ID(Customer Entry Form)",
      label: "Pass ID(Customer Entry Form)",
      type: "text",
      width: "12%",
    },
    {
      name: "CustomerType",
      label: "Customer Type",
      type: "text",
      width: "12%",
    },
    { name: "DateTime", label: "Date & Time", type: "date", width: "10%" },
    {
      name: "status",
      label: "Status",
      width: "12%",
      type: "select",
      options: [
        { value: "pending", label: "Pending" },
        { value: "completed", label: "Completed" },
        { value: "cancelled", label: "Cancelled" },
      ],
    },
  ];

  // 🔍 Apply filters
  const filteredContacts = useMemo(() => {
    return contactsWithSiNo.filter((item) => {
      return Object.entries(filters).every(([key, value]) => {
        if (!value) return true;
        const itemValue = item[key]?.toString().toLowerCase();
        if (key === "creation") return item[key]?.split(" ")[0] === value;
        if (key === "status") return item[key] === value;
        if (key === "siNo") return item.siNo.toString() === value.toString();
        return itemValue?.includes(value.toLowerCase());
      });
    });
  }, [contactsWithSiNo, filters]);

  // 3️⃣ Paginate after filtering
  const paginatedData = filteredContacts.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );
  useEffect(() => {
    if (pageSize > 0) {
      refetchGetContact();
    }
  }, [pageSize, currentPage, screenHeight, screenScaling]);

  const handleView = (id) => {
    navigate("/master/customerdatafeedback/view-details/customerdataandfeedbackform");
  };

  const handleEdit = (id) => {};

  const handleDelete = (id) => {
    setDelSelectedId(id);
    setDelPopupVisible(true);
    setAlreadySubmitData(false);
    setDelmessage("Are you sure you want to Delete this Contact?");
  };

  const delHandleCancel = () => {
    setDelPopupVisible(false);
    setDelSelectedId(null);
  };

  const delHandleConfirm = async () => {
    try {
      await deleteDoc({
        doctype: "Contact",
        name: delSelectedId,
      }).unwrap();
      setDelmessage(`Contact ${delSelectedId} deleted successfully!`);
      setDelDone(true);
      setTimeout(() => {
        setDelPopupVisible(false);
        setDelSelectedId(null);
        setDelDone(false);
        refetchGetContact();
      }, 1000);
    } catch (err) {
      console.error("Deletion Failed:", err);

      let errorMessage = "Failed to delete the Contact!";

      //If the server is sending the error message , we will extract it.
      if (err?.data?._server_messages) {
        try {
          const messageArr = JSON.parse(err.data._server_messages);
          if (messageArr && messageArr.length > 0) {
            //parse inner json object
            const messageObj = JSON.parse(messageArr[0]);
            if (messageObj?.message) {
              //extract the exact message we want
              const fullMessage = messageObj.message;
              errorMessage = fullMessage.split("You must")[0].trim();
              //remove html in the message
              errorMessage = errorMessage.replace(/<[^>]+>/g, "");
            }
          }
        } catch (parseError) {
          console.error("Error parsing server messages:", parseError);
        }
      }
      setDelPopupVisible(true);
      setDelmessage(errorMessage);
      setAlreadySubmitData(true);
    } finally {
      // setTimeout(() => {
      //     setDelPopupVisible(false);
      //     setDelSelectedId(null);
      // }, 2000);
    }
  };

  const [columnsConfig, setColumnsConfig] = useState(() => [
    {
      header: "S. No.",
      name: "S. No.",
      accessor: "siNo",
      width: "5%",
      cellRenderer: (row) => row.siNo,
      sortable: false,
      visible: true,
    },
    {
      header: "Id",
      name: "Id",
      accessor: "Id",
      width: "17.7%",
      visible: true,
      sortable: true,
      cellRenderer: (row) => row.Id,
    },
    {
      header: "Customer",
      name: "CustomerName",
      accessor: "CustomerName",
      width: "17.7%",
      visible: true,
      sortable: true,
      cellRenderer: (row) => row.CustomerName?.split(" ")[0],
    },
    {
      header: "Contact No.",
      name: "ContactNo",
      accessor: "ContactNo",
      width: "17.7%",
      visible: true,
      sortable: true,
      cellRenderer: (row) => row.ContactNo?.split(" ")[0],
    },
    {
      header: "PassIDCustomer",
      name: "PassIDCustomerEntryForm",
      accessor: "PassIDCustomerEntryForm",
      width: "17.7%",
      sortable: false,
      visible: true,
    },

    {
      header: "Date & Time",
      name: "Date&Time",
      accessor: "DateTime",
      width: "17.7%",
      visible: true,
      sortable: true,
      cellRenderer: (row) => row.DateTime?.split(" ")[0],
    },

    {
      header: "Status",
      name: "Status",
      accessor: "status",
      width: "17.7%",
      sortable: true,
      visible: true,
      cellRenderer: (row) => {
        const statusText = row.status === "Passive" ? "Passive" : row.status;
        const color = row.status === "Passive" ? "#16A34A" : "#EF4444";
        return <span style={{ color }}>{statusText}</span>;
      },
    },
    {
      header: "Action",
      name: "Action",
      accessor: "action",
      width: "10%",
      visible: true,
      cellRenderer: (row) => (
        <ActionButtonDropdown
          id={row.name}
          onView={() => handleView()}
          onEdit={() => handleEdit(row.name)}
          onDelete={() => handleDelete(row.name)}
        />
      ),
    },
  ]);

  // Handle column configuration changes
  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1);
  };

  const handleSaveColumns = (selectedKeys, allFields) => {
    const updatedColumns = columnsConfig.map((column) => {
      return {
        ...column,
        visible: selectedKeys.includes(column.accessor),
      };
    });
    setColumnsConfig(updatedColumns);
  };
  const visibleColumns = useMemo(
    () => columnsConfig.filter((col) => col.visible === true),
    [columnsConfig]
  );

  const defaultSelectedColumns = useMemo(
    () =>
      columnsConfig
        .filter((col) => col.visible === true)
        .map((col) => ({
          fieldname: col.accessor,
          label: col.name,
        }))
        .filter((col) => col.fieldname),
    [columnsConfig]
  );
  const activeFilterCount = useMemo(() => {
    return Object.values(filters).filter(
      (val) => val !== null && val !== undefined && val !== ""
    ).length;
  }, [filters]);

  const actionButtons = [
    {
      className: "createbtnsfilter border-0 d-flex",
      style: { gap: "2px", height: "28px" },
      iconName: "IoFilterSharp",
      iconSize: 12,
      children:
        activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
      onClick: () => {
        setShowFilters((prev) => !prev);
        setShowColumnConfig(false);
      },
    },
    {
      className: "createbtnshowmore border-0 d-flex",
      style: { gap: "2px", height: "28px" },
      iconName: "MdOutlineRemoveRedEye",
      iconSize: 12,
      children: "Show more",
      onClick: () => {
        setShowColumnConfig((prev) => !prev);
        setShowFilters(false);
      },
    },
    {
      className: "createbtnexport border-0 d-flex",
      style: { gap: "2px", height: "28px" },
      iconName: "RiFileExcel2Fill",
      iconSize: 12,
      children: "Export Excel",
      onClick: () => setShowExportPopup(true),
    },
    {
      className: "custom-btn-00989 d-flex",
      to: "/master/customerdatafeedback/create-customerdatafeedbackform/customerdatafeedbackform",
      iconName: "FiPlus",
      style: { gap: "2px", height: "28px" },
      children: "New Customer Data & Feedback Form",
    },
  ];
  const accessors = columnsConfig
    .filter(
      (column) => column.accessor !== "siNo" && column.accessor !== "action"
    )
    .map((column) => column.accessor);

  return (
    <div
      className="container-fluid d-flex flex-column"
      style={{ flexGrow: "1" }}
    >
      <Tabs />
      <ListLayout
        breadcrumbItems={[
          { label: "Master" },
          {
            label: "Customer Data & Feedback Form List",
            style: { color: "#4b002b" },
          },
        ]}
        actionButtons={actionButtons}
      >
        {showFilters && (
          <ListFilters
            filtersConfig={filtersConfig}
            onFilterChange={handleFilterChange}
            currentFilters={filters}
            setShowFilters={setShowFilters}
          />
        )}

        {showColumnConfig && (
          <ConfigureColumnsNew
            show={showColumnConfig}
            onClose={() => setShowColumnConfig(false)}
            onSave={handleSaveColumns}
            docType="Contact"
            defaultSelected={defaultSelectedColumns}
            fieldsData={columnsConfig.map((col) => ({
              fieldname: col.accessor,
              label: col.name,
            }))}
            disabledFields={["siNo", "status", "action", "creation", "name"]}
          />
        )}

        <Table
          columns={visibleColumns}
          data={paginatedData}
          loading={isLoading}
        />

        <Pagination
          setCurrentPage={setCurrentPage}
          pageSize={pageSize}
          totalRecords={filteredContacts.length}
          currentPage={currentPage}
          className="mt-2 pb-3"
        />
        {delPopupVisible && (
          <DelConfirmPopup
            alredysubmitdata={alreadySubmitData}
            delSelectedId={delSelectedId}
            visible={delPopupVisible}
            message={delmessage}
            onConfirm={delHandleConfirm}
            onCancel={delHandleCancel}
            delDone={delDone}
          />
        )}
        {showExportPopup && (
          <ExportCSV
            doctype="Contact"
            fieldsData={accessors}
            onClose={() => setShowExportPopup(false)}
          />
        )}
      </ListLayout>
    </div>
  );
};

export default MainList;
